import React, { useCallback, useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Route, Routes, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";

import { BaseUrl } from "../../common/FormatHelper";

import ApiView from "../../components/ApiView/ApiView";
import DeveloperView from "../../components/DeveloperView/DeveloperView";
import EduFadProfile from "../../components/EduFadProfile/EduFadProfile";
import ProfileNavigation from "../../components/ProfileNavigation/ProfileNavigation";

import axios from "axios";

const api = axios.create({
	baseURL: BaseUrl(),
});

const ProviderProfile = (props) => {
	const params = useParams();
	
	const [provider, setProvider] = useState(null);
	const [locations, setLocation] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [url, setUrl] = useState(null);

	const fetchProviderData = useCallback(async (provider_id) => {
		setIsLoading(true);
		setError(null);
		setUrl(null);

		try {
			const provider_response = await api.get(`/v3/providers/${provider_id}`);
			setProvider(provider_response.data.provider);

			const locations_response = await api.get(`/v3/providers/${provider_id}/locations`);
			setLocation(locations_response.data.locations);
		} catch (ex) {
			setError(ex.message);
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchProviderData(params.id);
	} , [fetchProviderData, params.id]);

	let content = <Loader type="Oval" color="#00BFFF" height={100} width={100} timeout={10000} className="loader" />;

	if (!isLoading) {
		if(error) {
			content = <Card><Card.Body>{error}</Card.Body></Card>;
		} else if(provider === null) {
			content = <Card><Card.Body>No provider found!</Card.Body></Card>;
		} else {
			content = (
				<React.Fragment>
					<ProfileNavigation provider={provider} url={url} />
					<Routes>
						<Route index element={<EduFadProfile provider={provider} url={url} />} />
						<Route path="api" element={<ApiView provider={provider} url={url} />} />
						<Route path="developer" element={<DeveloperView provider={provider} url={url} locations={locations}/>} />
					</Routes>
				</React.Fragment>
			);
		}
	}

	return content;
}

export default ProviderProfile;
